import React from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";

const BaskanMesaj = () => {
  return (
    <div className="surface-ground flex justify-content-center p-1 md:p-4">
      <div className="">
        <Card className="p-1 md:p-4 shadow-2 border-round">
          <h2 className="text-center text-primary font-bold mb-4">
            OSBÜK, OSB’LERİ YEŞİL KALKINMA SÜRECİNDE ROL MODEL HALİNE GETİRECEK
          </h2>
          <p className="line-height-3 text-justify">
            Türkiye, 60 yılı aşan OSB tecrübesine sahip. Bu tecrübe ile yatırım, üretim, istihdam ve ihracat ekseninde
            organize sanayi bölgelerimiz, uyguladığı projeler ve tüm zorlu şartlarda gösterdiği üretim kararlılığı ile
            sanayi sektörünün lokomotifi olmayı başardı.
          </p>

          <p className="line-height-3 text-justify">
            Ülkemizin dört bir yanında kurulan organize sanayi bölgelerimizin sayıları 406’ya ulaştı ve 2 milyon 700 bin
            kişiye doğrudan istihdam sağlar hale geldik. Organize sanayi bölgelerimiz 68 bini aşkın fabrikada,
            Türkiye’nin sanayi üretiminin yüzde 45’ini gerçekleştirirken, yine Türkiye’nin 1000 Büyük Sanayi
            Kuruluşu’ndan 648’ine de ev sahipliği yapıyor.
          </p>
          <p className="line-height-3 text-justify">
            Organize sanayi bölgelerimiz sanayi üretiminin yanı sıra, altyapı ve üstyapı hizmetlerinden meslek
            liselerine, teknoloji geliştirme bölgelerinden itfaiye teşkilatlarına, lojistikten dış ticaret istihbarat
            merkezlerine kadar yatırımcısına çok geniş bir yelpazede hizmetler sunuyor. Katılımcı sanayicilerine, adeta
            şehirlere benzer birer yaşam alanı imkânı sunan organize sanayi bölgelerimiz, dinamik ve etkin yapısı ile
            güncel gelişmelere hızla cevap verecek bir yapıya sahip.
          </p>

          <h4 className="text-primary font-bold mt-6">Yeşil dönüşümün avantajlarını OSB’lerle fırsata çevireceğiz</h4>
          <p className="line-height-3 text-justify">
            Ülkemizin en büyük ticari ortağı olan Avrupa Birliği, 2019’da açıkladığı Avrupa Yeşil Mutabakatı ile yeni
            bir süreç başlattı. Ülkemiz de bu yeni gelişmelere ilişkin Yeşil Mutabakat Eylem Planı’nı hayata geçirdi.
            Böylece Sınırda Karbon Düzenleme Mekanizması, AB Net Sıfır Sanayi Yasası, Emisyon Ticaret Sistemi, Döngüsel
            Ekonomi ile sürdürülebilir sanayi ve tarım politikaları gibi daha pek çok konu da sanayi sektörünün bir
            numaralı gündemi haline geldi.
          </p>

          <p className="line-height-3 text-justify">
            OSBÜK olarak biz de tüm bu gelişmeler ışığında Yeşil Dönüşüm ve Sürdürülebilirlik Merkezimizi kurduk. OSBÜK
            Yeşil Dönüşüm ve Sürdürülebilirlik Merkezi ile yeşil dönüşümde kritik bir rol üstlenen organize sanayi
            bölgelerimize politika oluşturacağız. Ayrıca yeşil dönüşüm finansmanından kurumsal iş birliklerine kadar 17
            ara başlıkta da farklı projelere imza atacağız.
          </p>

          <p className="line-height-3 text-justify">
            İlkini Antalya’da düzenlediğimiz OSB’lerin Yeşil ve Dijital Dönüşümü İçin Stratejik Plan Çalıştayı gibi
            verimli çalışmalarla merkezimizin çalışmalarını güçlendirecek, yeşil dönüşümün avantajlarını organize sanayi
            bölgelerimizle fırsata çevireceğiz. OSBÜK olarak merkezimiz aracılığıyla sürdürülebilir sanayi için, karbon
            ayak izinin azaltılmasından enerji verimliliğine, dijital teknolojilerin üretimde daha fazla kullanılmasına
            kadar farklı başarı öykülerine imza atmayı hedefliyoruz.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default BaskanMesaj;
